import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { px } from 'framer-motion';

// Fix default icon issue with Leaflet in React
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

type Pin = {
  name: string;
  lat: number;
  lng: number;
  description: string;
};

const FreeMap: React.FC = () => {
  const [pins, setPins] = useState<Pin[]>([]);

  useEffect(() => {
    fetch('/pins_no_duplicates.json')
      .then(res => res.json())
      .then(data => setPins(data));
  }, []);

  // Show alert every 2 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      alert("This is the Free map, it has only a few pins. The subscription version has over 60,000 in Poland and is only 10PLN");
    }, 30000); // 120,000 ms = 2 minutes

    // Optional: show once on mount
    alert("This is the Free map, it has only a few pins. The subscription version has over 60,000 in Poland and is only 10PLN");

    return () => clearInterval(interval);
  }, []);

  const center: [number, number] = pins.length
    ? [pins[0].lat, pins[0].lng]
    : [51.1, 17.0];

  return (
    <div className="map-page" style={{ height: '80vh', width: '100%' }}>
      <MapContainer center={center} zoom={12} style={{ height: '100%', width: '100%'}} className="leaflet-blur">
        <TileLayer
          attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MarkerClusterGroup maxClusterRadius={15}>
          {pins.map((pin, idx) => (
            <Marker key={idx} position={[pin.lat, pin.lng]}>
              <Popup className='noblur'>
                <strong>{pin.name}</strong>
                <br />
                {"To view the information on this spot, please support the project by subscribing to the paid version."}
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default FreeMap;